(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(() => {
  const header = document.querySelector('[data-hs-header]');
  if (!header) return;

  const toggle = header.querySelector('[data-hs-menu-toggle]');
  const panel = header.querySelector('[data-hs-mobile-nav]');
  const closeLinks = header.querySelectorAll('[data-hs-menu-close]');

  let closeTimeout;
  let previousOverflow = '';
  let inertTargets = [];
  let inertState = [];
  const setOpen = (open, restoreFocus = true) => {
    if (!toggle || !panel) return;
    clearTimeout(closeTimeout);
    const wasOpen = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    if (open) {
      if (!wasOpen) {
        previousOverflow = document.body.style.overflow;
        inertTargets = [...document.querySelectorAll('main, footer')];
        inertState = inertTargets.map(el => el.inert);
        inertTargets.forEach(el => { el.inert = true; });
      }
      panel.hidden = false;
      requestAnimationFrame(() => { panel.classList.add('is-open'); panel.querySelector('a')?.focus(); });
      document.body.style.overflow = 'hidden';
    } else {
      panel.classList.remove('is-open');
      if (wasOpen) {
        document.body.style.overflow = previousOverflow;
        inertTargets.forEach((el, i) => { el.inert = inertState[i]; });
        if (restoreFocus) toggle.focus();
      }
      panel.hidden = true;
    }
  };
  toggle?.addEventListener('click', () => setOpen(toggle.getAttribute('aria-expanded') !== 'true'));
  closeLinks.forEach(link => link.addEventListener('click', () => setOpen(false)));
  document.addEventListener('keydown', event => {
    if (toggle?.getAttribute('aria-expanded') !== 'true') return;
    if (event.key === 'Escape') { event.preventDefault(); setOpen(false); }
    if (event.key === 'Tab') {
      const links = [...panel.querySelectorAll('a[href]')];
      const first = links[0], last = links[links.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); toggle.focus(); }
      else if (event.shiftKey && document.activeElement === toggle) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); toggle.focus(); }
      else if (!event.shiftKey && document.activeElement === toggle) { event.preventDefault(); first?.focus(); }
    }
  });
  window.matchMedia('(min-width: 900px)').addEventListener('change', event => { if (event.matches) setOpen(false, false); });

  // Sticky shadow on scroll
  let lastY = 0;
  const onScroll = () => {
    const y = window.scrollY || 0;
    header.classList.toggle('is-scrolled', y > 12);
    lastY = y;
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holy-brand-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = () => {
    document.querySelectorAll('[data-holy-countdown]').forEach(timer => {
      if (timer.dataset.initialized) return;
      timer.dataset.initialized = 'true';
      const value = timer.dataset.endAt || '';
      const explicit = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(Z|[+-]\d{2}:\d{2})$/.test(value);
      const deadline = explicit ? Date.parse(value) : NaN;
      if (!Number.isFinite(deadline)) { timer.hidden = true; return; }
      let interval;
      const render = () => {
        let remaining = deadline - Date.now();
        if (remaining <= 0) {
          timer.hidden = true;
          const hero = timer.closest('.holy-hero');
          hero?.querySelectorAll('.holy-deal__price, .holy-deal__save, .holy-deal__badge').forEach(el => { el.hidden = true; });
          const ended = hero?.querySelector('.holy-deal__ended');
          if (ended) ended.hidden = false;
          clearInterval(interval);
          return false;
        }
        timer.hidden = false;
        const units = [['[data-days]', 86400000], ['[data-hours]', 3600000], ['[data-minutes]', 60000], ['[data-seconds]', 1000]];
        units.forEach(([selector, divisor]) => {
          const element = timer.querySelector(selector);
          if (element) element.textContent = String(Math.floor(remaining / divisor)).padStart(2, '0');
          remaining %= divisor;
        });
        return true;
      };
      if (render()) interval = setInterval(() => {
        if (!timer.isConnected) { clearInterval(interval); return; }
        render();
      }, 1000);
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  // Toast helper
  const showToast = (msg, isError) => {
    let t = document.getElementById('hs-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'hs-toast';
      t.setAttribute('role', 'status');
      t.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%) translateY(20px);z-index:9998;padding:14px 22px;border-radius:14px;background:#0f0f0f;color:#fff;font-weight:700;font-size:14px;box-shadow:0 16px 40px rgba(0,0,0,.25);opacity:0;transition:opacity .25s,transform .25s;pointer-events:none;max-width:min(90vw,360px);text-align:center';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.style.background = isError ? '#8b2e26' : '#0f0f0f';
    requestAnimationFrame(() => {
      t.style.opacity = '1';
      t.style.transform = 'translateX(-50%) translateY(0)';
    });
    clearTimeout(t._hide);
    t._hide = setTimeout(() => {
      t.style.opacity = '0';
      t.style.transform = 'translateX(-50%) translateY(20px)';
    }, 2800);
  };

  const updateCartCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count < 1;
    });
    // If no badge exists and count > 0, create one on cart links
    if (count > 0) {
      document.querySelectorAll('.hs-header__cart').forEach((link) => {
        let badge = link.querySelector('[data-cart-count]');
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'hs-header__cart-count';
          badge.setAttribute('data-cart-count', '');
          link.appendChild(badge);
        }
        badge.textContent = count;
        badge.hidden = false;
      });
    }
  };

  document.querySelectorAll('.product-form').forEach((form) => {
    const input = form.querySelector('.product-form__qty-input');
    const minus = form.querySelector('[data-qty-minus]');
    const plus = form.querySelector('[data-qty-plus]');
    const submit = form.querySelector('.product-form__submit');

    if (input) {
      minus?.addEventListener('click', () => {
        input.value = Math.max(1, parseInt(input.value, 10) - 1 || 1);
      });
      plus?.addEventListener('click', () => {
        input.value = Math.min(99, parseInt(input.value, 10) + 1 || 1);
      });
    }

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!submit || submit.disabled) return;

      const original = submit.textContent;
      submit.disabled = true;
      submit.textContent = 'Adding…';

      try {
        const fd = new FormData(form);
        const res = await fetch(window.Shopify?.routes?.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          body: fd,
          headers: { 'Accept': 'application/json' }
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || err.message || 'Could not add to cart');
        }
        const item = await res.json();
        // Refresh cart count
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        updateCartCount(cart.item_count);
        showToast('Added to cart');
        submit.textContent = 'Added ✓';
        setTimeout(() => { submit.textContent = original; submit.disabled = false; }, 1600);
      } catch (err) {
        showToast(err.message || 'Something went wrong', true);
        submit.textContent = original;
        submit.disabled = false;
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
